import { createFileRoute } from '@tanstack/react-router';
import {
  CHOICES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';
import { EditKassenzeichen } from '../../../features/kassenzeichen/editKassenzeichen';

function EditKassenzeichenRoute() {
  const { kassenzeichenId } = Route.useParams();
  return <EditKassenzeichen kassenzeichenId={kassenzeichenId} />;
}

export const Route = createFileRoute(
  '/auswahlfelder/kassenzeichen/$kassenzeichenId_/bearbeiten',
)({
  component: EditKassenzeichenRoute,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CHOICES_PERMISSIONS, 'EDIT'),
  ),
});

export const EditKassenzeichenRoute_ = Route;
